



























import { Audit } from '@/api';
import { Component, InjectReactive, Vue } from 'vue-property-decorator';

import { FeedProduct, feedProductAuditFields } from '../../../models';
import ChangelogLink from '@/components/display/changelog-link.vue';

@Component({
	components: { ChangelogLink },
})
export default class FeedProductAuditLog extends Vue {
	@InjectReactive('feedProduct')
	private feedProduct!: FeedProduct;

	public get audits(): Audit[] {
		return this.feedProduct.audits;
	}

	public get fields(): { key: string; label: string }[] {
		return feedProductAuditFields;
	}
}
